var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNervousSweat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10h.01M15 10h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15h5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v2M20 7h-2M6 5v2M4 7h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4l-1 1M5 4l1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNervousSweat);
export default __webpack_public_path__ + "static/media/nervous-sweat.603fa1639de64bb22959454da4939745.svg";
export { ForwardRef as ReactComponent };